module.exports = __webpack_public_path__ + "img/example9.1fdc0496.jpg";